// extracted by mini-css-extract-plugin
export default {"container":"_1XzMZ","insideItemModal":"_3KMZC","pimple":"_3RGM1","updatedIndicationText":"_19fY2","insideModal":"_32Il1","wired":"_5rDKU"};